import React from 'react';
import PurchaseRequestForm from '../../components/PurchaseRequest/PurchaseRequestForm';

const PurchaseRequestFormPage = () => {
  return <PurchaseRequestForm />;
};

export default PurchaseRequestFormPage;